module.exports = __webpack_public_path__ + "img/banner_news.6473443e.jpg";